import React from 'react';
import { FaqPublic } from 'components/faq/FaqPublic';
import { useOidcAuthentication } from '@cp-shared-19/frontend-ui';
import { FaqPrivate } from 'components/faq/FaqPrivate';

export const FaqPage: React.FC = () => {
    const { isAuthenticated } = useOidcAuthentication();
    if (isAuthenticated) {
        return <FaqPrivate />;
    } else {
        return <FaqPublic />;
    }
};
